var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLimit)?_c('Breadcrumb',{ref:"breadcrumb",staticClass:"i-layout-header-breadcrumb"},_vm._l((_vm.items),function(item){return _c('BreadcrumbItem',{key:item.path},[_c('i-menu-head-title',{attrs:{"item":item,"hide-icon":!_vm.showBreadcrumbIcon}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }